    <div
        class="surface-card rounded-3xl p-6 md:p-8 max-w-lg w-full max-h-[95vh] overflow-y-auto border border-border shadow-lg animate-fadeIn antialiased relative selection:bg-primary/20">

        <div
            class="absolute right-0 top-0 w-24 h-32 bg-gradient-to-bl from-primary/10 to-transparent pointer-events-none rounded-tr-3xl">
        </div>

        <div class="flex items-center justify-between mb-6 pb-4 border-b border-dashed border-border-subtle">
            <div class="flex items-center gap-3">
                <div
                    class="w-10 h-10 bg-primary/10 border border-primary/20 rounded-xl flex items-center justify-center text-primary shadow-sm shrink-0">
                    <i class="fa-solid fa-handshake-slant text-sm"></i>
                </div>
                <div>
                    <h4 class="text-[10px] font-black uppercase tracking-widest text-text-muted font-mono">Negotiation Suite
                    </h4>
                    <h3 class="text-base sm:text-lg font-black text-text-primary tracking-tight mt-0.5">Make an Offer</h3>
                </div>
            </div>

            <button
                class="text-text-muted hover:text-text-primary hover:bg-surface-hover border border-transparent hover:border-border-subtle rounded-xl p-2.5 transition-all active:scale-90 cursor-pointer shrink-0"
                (click)="onClose()" title="Close Modal">
                <i class="fa-solid fa-xmark text-sm block w-4 h-4 flex items-center justify-center"></i>
            </button>
        </div>

        <form class="space-y-5" (ngSubmit)="onSubmit()" #offerForm="ngForm">

            @if (errorMessage) {
            <div
                class="rounded-2xl bg-error/10 border border-error/20 p-4 text-xs font-semibold text-error flex items-start gap-2.5 animate-fadeIn">
                <i class="fa-solid fa-circle-exclamation text-sm shrink-0 mt-0.5 animate-pulse"></i>
                <span class="leading-relaxed">{{ errorMessage }}</span>
            </div>
            }

            @if (successMessage) {
            <div
                class="rounded-2xl bg-success/10 border border-success/20 p-4 text-xs font-semibold text-success space-y-2 animate-fadeIn">
                <div class="flex items-start gap-2.5">
                    <i class="fa-solid fa-circle-check text-sm shrink-0 mt-0.5 text-success"></i>
                    <span class="leading-relaxed">{{ successMessage }}</span>
                </div>

                @if (createdOfferStatus || createdOfferId) {
                <div
                    class="pt-2 border-t border-success/20 grid grid-cols-2 gap-2 font-mono text-[10px] text-success uppercase tracking-wider">
                    @if (createdOfferStatus) {
                    <div class="truncate">Status: <span class="font-black text-success">{{ createdOfferStatus }}</span>
                    </div>
                    }
                    @if (createdOfferId) {
                    <div class="text-right truncate" [title]="createdOfferId">ID: <span
                            class="font-black text-success">#{{ createdOfferId }}</span></div>
                    }
                </div>
                }
            </div>
            }

            <div class="space-y-4">

                <div class="space-y-1.5">
                    <label
                        class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                        <i class="fa-solid fa-user-tie text-primary text-[10px]"></i>
                        <span>Full Name</span>
                    </label>
                    <input type="text" name="name" [(ngModel)]="formData.name"
                        class="w-full px-4 py-3 text-sm font-semibold text-text-primary placeholder-text-muted bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all duration-200"
                        placeholder="Enter your full name" required>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div class="space-y-1.5">
                        <label
                            class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                            <i class="fa-solid fa-phone-volume text-primary text-[10px]"></i>
                            <span>Phone Number</span>
                        </label>
                        <input type="tel" name="phone" [(ngModel)]="formData.phone"
                            class="w-full px-4 py-3 text-sm font-semibold text-text-primary placeholder-text-muted bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all duration-200"
                            placeholder="+20 1XX XXX XXXX" required>
                    </div>
                    <div class="space-y-1.5">
                        <label
                            class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                            <i class="fa-solid fa-envelope-open text-primary text-[10px]"></i>
                            <span>Email Address</span>
                        </label>
                        <input type="email" name="email" [(ngModel)]="formData.email"
                            class="w-full px-4 py-3 text-sm font-semibold text-text-primary placeholder-text-muted bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all duration-200"
                            placeholder="your.email@domain.com" required>
                    </div>
                </div>

                <div class="space-y-1.5">
                    <label
                        class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                        <i class="fa-solid fa-money-bill-wave text-primary text-[10px]"></i>
                        <span>Offer Price (EGP)</span>
                    </label>
                    <div class="relative flex items-center">
                        <input type="number" name="offerPrice" [(ngModel)]="formData.offerPrice"
                            class="w-full pl-4 pr-12 py-3 text-sm font-black text-text-primary font-mono placeholder-text-muted bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all duration-200"
                            placeholder="3500000" required>
                        <span
                            class="absolute right-4 text-[10px] font-black uppercase tracking-widest text-text-muted font-mono pointer-events-none">EGP</span>
                    </div>
                </div>

                <div class="space-y-1.5">
                    <label
                        class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                        <i class="fa-solid fa-wallet text-primary text-[10px]"></i>
                        <span>Payment Method</span>
                    </label>
                    <div class="relative">
                        <select name="paymentMethod" [(ngModel)]="formData.paymentMethod"
                            class="w-full px-4 py-3 text-sm font-bold text-text-primary bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all duration-200 appearance-none cursor-pointer">
                            <option value="cash" class="bg-bg-secondary">Cash Payment</option>
                            <option value="installment" class="bg-bg-secondary">Installment Plan</option>
                        </select>
                        <div class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-text-muted text-xs">
                            <i class="fa-solid fa-chevron-down"></i>
                        </div>
                    </div>
                </div>

                @if (formData.paymentMethod === 'installment') {
                <div
                    class="grid grid-cols-3 gap-3 p-4 bg-primary/5 border border-primary/20 rounded-2xl animate-slideDown">

                    <div class="space-y-1.5">
                        <label class="block text-[9px] font-black uppercase tracking-wider text-text-muted font-mono">Down
                            Payment</label>
                        <input type="number" name="downPaymentAmount" [(ngModel)]="formData.downPaymentAmount"
                            [required]="formData.paymentMethod === 'installment'" min="1"
                            class="w-full px-3 py-2 text-xs font-bold text-text-primary font-mono bg-bg-secondary border border-border rounded-xl focus:border-primary outline-none transition-colors"
                            placeholder="9000" />
                    </div>

                    <div class="space-y-1.5">
                        <label
                            class="block text-[9px] font-black uppercase tracking-wider text-text-muted font-mono">Duration
                            (Yrs)</label>
                        <input type="number" name="years" [(ngModel)]="formData.years"
                            [required]="formData.paymentMethod === 'installment'" min="1"
                            class="w-full px-3 py-2 text-xs font-bold text-text-primary font-mono bg-bg-secondary border border-border rounded-xl focus:border-primary outline-none transition-colors"
                            placeholder="1" />
                    </div>

                    <div class="space-y-1.5">
                        <label
                            class="block text-[9px] font-black uppercase tracking-wider text-text-muted font-mono">Interest
                            (%)</label>
                        <input type="number" name="interestRate" [(ngModel)]="formData.interestRate"
                            [required]="formData.paymentMethod === 'installment'" min="0" step="0.1"
                            class="w-full px-3 py-2 text-xs font-bold text-text-primary font-mono bg-bg-secondary border border-border rounded-xl focus:border-primary outline-none transition-colors"
                            placeholder="1.5" />
                    </div>

                </div>
                }

                <div class="space-y-1.5">
                    <label
                        class="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-text-muted font-mono">
                        <i class="fa-solid fa-paragraph text-primary text-[10px]"></i>
                        <span>Additional Notes <span
                                class="text-text-secondary font-medium lowercase font-sans">(optional)</span></span>
                    </label>
                    <textarea name="notes" [(ngModel)]="formData.notes" rows="3"
                        class="w-full px-4 py-3 text-sm font-semibold text-text-primary placeholder-text-muted bg-bg-secondary/50 hover:bg-surface-hover border border-border rounded-2xl focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none resize-none transition-all duration-200"
                        placeholder="Specify any special terms or legal contingencies..."></textarea>
                </div>

            </div>

            <div class="flex gap-3 pt-5 mt-5 border-t border-dashed border-border-subtle">

                <button type="button" (click)="onClose()"
                    class="flex-1 px-5 py-3.5 border border-border-subtle hover:border-border text-xs font-black uppercase tracking-widest font-mono text-text-secondary hover:text-text-primary bg-bg-secondary hover:bg-surface-hover rounded-2xl transition-all active:scale-[0.98] cursor-pointer">
                    Cancel
                </button>

                <button type="submit" [disabled]="!offerForm.valid || isSubmitting"
                    class="btn-primary flex-1 px-5 py-3.5 text-xs font-black uppercase tracking-widest font-mono rounded-2xl transition-all duration-300 active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none flex items-center justify-center gap-2">
                    @if (isSubmitting) {
                    <i class="fa-solid fa-spinner-third fa-spin text-sm"></i>
                    <span>Submitting...</span>
                    } @else {
                    <i class="fa-solid fa-paper-plane text-[11px]"></i>
                    <span>Submit Offer</span>
                    }
                </button>

            </div>
        </form>